module.exports = "/content/6787f8dc916dd3c11c77f99a133daf05.png";